import commaNumber from 'comma-number'
import { makeNumbersFarsi } from '../utils/farsi'
import { addThousandsSeparator } from '../utils/format'

interface PropTypes {
  value: number | string | undefined
  currencyCode: string | undefined
  alternativeCurrencyCode: boolean
}

const CURRENCY_CODE_LITERALS = {
  IRR: '﷼',
  USD: 'دلار',
  EUR: 'یورو',
}

const Price = ({ value, currencyCode, alternativeCurrencyCode }: PropTypes) => {
  alternativeCurrencyCode =
    typeof alternativeCurrencyCode === 'boolean'
      ? alternativeCurrencyCode
      : false

  if (alternativeCurrencyCode) {
    value = value
      ? value.toString().substring(0, value.toString().length - 1)
      : ''
  }

  let formattedValue = value
    ? makeNumbersFarsi(addThousandsSeparator(value))
    : ''

  let currency =
    CURRENCY_CODE_LITERALS[currencyCode as keyof typeof CURRENCY_CODE_LITERALS]
  if (!currency) {
    currency = '﷼'
  }

  if (alternativeCurrencyCode) {
    if (currency === '﷼') {
      currency = 'تومان'
    }
  }

  if (value === 0) {
    currency = ''
    formattedValue = 'رایگان'
  }

  return (
    <span className='text-xl font-bold'>
      {commaNumber(formattedValue)} {currency}
    </span>
  )
}

export default Price
